import { render, staticRenderFns } from "./Report-pt-sessions-list.vue?vue&type=template&id=0ba8054f"
import script from "./Report-pt-sessions-list.vue?vue&type=script&lang=js"
export * from "./Report-pt-sessions-list.vue?vue&type=script&lang=js"
import style0 from "./Report-pt-sessions-list.vue?vue&type=style&index=0&id=0ba8054f&prod&lang=scss"
import style1 from "./Report-pt-sessions-list.vue?vue&type=style&index=1&id=0ba8054f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports